import { render, staticRenderFns } from "./preview-status.vue?vue&type=template&id=0e108573&scoped=true&"
import script from "./preview-status.vue?vue&type=script&lang=js&"
export * from "./preview-status.vue?vue&type=script&lang=js&"
import style0 from "./preview-status.vue?vue&type=style&index=0&id=0e108573&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e108573",
  null
  
)

/* custom blocks */
import block0 from "./locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fquake%2Fworkspace%2Fauction%2Ftokyo-auction-frontend%2Fsrc%2Fcomponents%2Fauction%2Fpreview-status.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports